(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart"] && !Shopify.designMode) return;
  try {
    (function() {
    // Initialize add-to-cart handler for all forms on the page
    // This runs once and handles all add-to-cart forms
    function initAddToCartForms() {
      const addToCartForms = document.querySelectorAll('.add-to-cart-form');
      
      addToCartForms.forEach(function(formWrapper) {
        const form = formWrapper.querySelector('form');
        const cartType = formWrapper.dataset.cartType || 'page';
        const button = formWrapper.querySelector('[data-add-to-cart-button]');
        
        if (!form || cartType !== 'drawer' || form.dataset.initialized) return;
        
        // Mark as initialized to prevent duplicate handlers
        form.dataset.initialized = 'true';
        
        // Store original button text
        const originalButtonText = button?.textContent || formWrapper.dataset.buttonText || 'Add to cart';
        
        form.addEventListener('submit', async function(e) {
          e.preventDefault();
          
          const formData = new FormData(form);
          const variantId = formData.get('id');
          const quantity = parseInt(formData.get('quantity') || '1', 10);
          
          if (!variantId) {
            console.error('No variant selected');
            return;
          }
          
          // Disable button during submission
          if (button) {
            button.disabled = true;
            button.textContent = 'Adding...';
          }
          
          try {
            // Add item to cart via AJAX
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: variantId,
                quantity: quantity
              })
            });
            
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Failed to add item to cart');
          }
          
          // Small delay to ensure Shopify's cart is fully updated
          await new Promise(resolve => setTimeout(resolve, 100));
          
          // Refresh cart drawer and open it
          if (window.cartDrawer) {
            await window.cartDrawer.refreshCart();
            window.cartDrawer.open();
          }
          
          // Dispatch cart add event
          document.dispatchEvent(new CustomEvent('cart:add'));
          
          // Re-enable button
          if (button) {
            button.disabled = false;
            button.textContent = originalButtonText;
          }
          } catch (error) {
            console.error('Error adding to cart:', error);
            alert(error.message || 'Failed to add item to cart. Please try again.');
            
            // Re-enable button
            if (button) {
              button.disabled = false;
              button.textContent = originalButtonText;
            }
          }
        });
      });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAddToCartForms);
    } else {
      initAddToCartForms();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer {
    constructor() {
      this.cart = null;
      this.init();
    }

    init() {
      this.cartDrawer = document.getElementById('cart-drawer');
      this.cartBody = document.querySelector('[data-cart-drawer-body]');
      this.cartForm = document.querySelector('[data-cart-drawer-form]');
      this.cartFooter = document.querySelector('.cart-drawer__footer');
      this.closeButtons = document.querySelectorAll('[data-cart-drawer-close]');
      this.toggleButton = document.querySelector('[data-cart-drawer-toggle]');
      
      if (!this.cartDrawer) return;

      // Toggle button
      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle();
        });
      }

      // Close buttons
      this.closeButtons.forEach(button => {
        button.addEventListener('click', () => this.close());
      });

      // Attach event listeners to cart form
      this.attachCartFormListeners();
    }

    attachCartFormListeners() {
      // Use event delegation on cartBody (which doesn't get replaced) to avoid duplicate listeners
      // This way, listeners persist even when the form HTML is replaced
      if (!this.cartBody || this.cartBody.dataset.listenersAttached) return;
      
      // Mark as attached to prevent duplicates
      this.cartBody.dataset.listenersAttached = 'true';
      
      // Quantity buttons - use event delegation on cartBody
      this.cartBody.addEventListener('click', (e) => {
        const btn = e.target.closest('.qty-btn');
        if (!btn) return;
        
        const container = btn.parentElement;
        const input = container.querySelector('.qty-input');
        const action = btn.dataset.action;
        const current = parseInt(input.value || '0', 10);
        const next = action === 'increment' ? current + 1 : Math.max(0, current - 1);
        
        if (next === 0) {
          // Remove item if quantity is 0
          const item = container.closest('[data-cart-item]');
          const key = item?.dataset.cartItemKey;
          if (key) {
            this.removeItem(key);
          }
        } else {
          input.value = next;
          this.updateCart();
        }
      });

      // Remove buttons - use event delegation on cartBody
      this.cartBody.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-remove-item]');
        if (!btn) return;
        
        const key = btn.dataset.lineItemKey;
        if (key) {
          this.removeItem(key);
        }
      });

      // Quantity input changes - use event delegation on cartBody
      this.cartBody.addEventListener('change', (e) => {
        if (e.target.matches('.qty-input')) {
          const value = parseInt(e.target.value || '0', 10);
          if (value === 0) {
            const item = e.target.closest('[data-cart-item]');
            const key = item?.dataset.cartItemKey;
            if (key) {
              this.removeItem(key);
            }
          } else {
            this.updateCart();
          }
        }
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });
    }

    async fetchCart() {
      try {
        const response = await fetch('/cart.js');
        this.cart = await response.json();
        return this.cart;
      } catch (error) {
        console.error('Error fetching cart:', error);
        return null;
      }
    }

    async updateCart() {
      if (!this.cartForm) return;

      const formData = new FormData(this.cartForm);
      const updates = {};

      formData.getAll('updates[]').forEach((value, index) => {
        const inputs = this.cartForm.querySelectorAll('.qty-input');
        if (inputs[index]) {
          const key = inputs[index].closest('[data-cart-item]')?.dataset.cartItemKey;
          if (key) {
            updates[key] = parseInt(value, 10);
          }
        }
      });

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });

        if (response.ok) {
          await this.refreshCart();
          this.updateCartCount();
        }
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }

    async removeItem(key) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        });

        if (response.ok) {
          await this.refreshCart();
          this.updateCartCount();
        }
      } catch (error) {
        console.error('Error removing item:', error);
      }
    }

    buildCartBodyHTML(cart) {
      if (!cart || cart.item_count === 0) {
        return '<div class="cart-drawer__empty"><p>Your cart is empty</p></div>';
      }

      let itemsHTML = '<form action="/cart" method="post" class="cart-drawer__form" data-cart-drawer-form><div class="cart-drawer__items">';
      
      cart.items.forEach(item => {
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' 
          ? `<span class="text-small">${this.escapeHtml(item.variant_title)}</span>` 
          : '';
        
        // Handle image URL - cart.js returns full URL or we need to construct it
        let imageUrl = '';
        if (item.image) {
          imageUrl = item.image;
          // If it's a relative URL, make it absolute
          if (imageUrl.startsWith('//')) {
            imageUrl = window.location.protocol + imageUrl;
          } else if (imageUrl.startsWith('/')) {
            imageUrl = window.location.origin + imageUrl;
          }
        }
        
        const imageHTML = imageUrl 
          ? `<img src="${this.escapeHtml(imageUrl)}" alt="${this.escapeHtml(item.product_title)}" width="120" height="120" loading="lazy">`
          : '';

        itemsHTML += `
          <div class="cart-drawer__item" data-cart-item data-cart-item-key="${this.escapeHtml(item.key)}">
            <div class="cart-drawer__item-image">
              <a href="${this.escapeHtml(item.url)}" class="image-wrapper image-wrapper--cover image-wrapper--3-4">${imageHTML}</a>
            </div>
            <div class="cart-drawer__item-details">
              <div class="cart-drawer__item-title">
                <h3 class="h5"><a href="${this.escapeHtml(item.url)}">${this.escapeHtml(item.product_title)}</a></h3>
                ${variantTitle}
              </div>
              <div class="cart-drawer__item-price">${this.formatMoney(item.final_line_price)}</div>
              <div class="cart-drawer__item-actions">
                <div class="cart-drawer__item-qty item-qty">
                  <button type="button" class="qty-btn" data-action="decrement" aria-label="Decrease">-</button>
                  <input class="qty-input" type="number" name="updates[]" value="${item.quantity}" min="0" step="1" data-quantity-input>
                  <button type="button" class="qty-btn" data-action="increment" aria-label="Increase">+</button>
                </div>
                <button type="button" class="cart-drawer__item-remove" data-remove-item data-line-item-key="${this.escapeHtml(item.key)}">Remove</button>
              </div>
            </div>
          </div>
        `;
      });
      
      itemsHTML += '</div></form>';
      return itemsHTML;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    async refreshCart() {
      const cart = await this.fetchCart();
      if (!cart) return;

      // Update cart body by building HTML from cart data
      if (this.cartBody) {
        try {
          this.cartBody.innerHTML = this.buildCartBodyHTML(cart);
          // Re-initialize form reference
          this.cartForm = document.querySelector('[data-cart-drawer-form]');
          // Event listeners are already attached via event delegation on cartBody,
          // so no need to re-attach them
        } catch (error) {
          console.error('Error refreshing cart items:', error);
        }
      }

      // Update footer visibility and totals
      if (this.cartFooter) {
        if (cart.item_count === 0) {
          this.cartFooter.style.display = 'none';
        } else {
          this.cartFooter.style.display = 'block';
          const totalElement = this.cartFooter.querySelector('[data-cart-total]');
          if (totalElement) {
            totalElement.textContent = this.formatMoney(cart.total_price);
          } else {
            console.error('Cart total element not found in footer');
          }
        }
      } else {
        console.error('Cart footer not found');
      }

      // Update count in drawer
      const countElement = document.querySelector('[data-cart-count]');
      if (countElement) {
        countElement.textContent = `(${cart.item_count})`;
      }
      
      // Update count in header
      this.updateCartCount();

      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }

    updateCartCount() {
      // Update cart count in header (for both link and button)
      const headerCountLink = document.querySelector('.header__icons a[href*="cart"] sup');
      const headerCountButton = document.querySelector('.header__icons button[data-cart-drawer-toggle] sup');
      const headerCount = headerCountLink || headerCountButton;
      
      if (headerCount) {
        const count = this.cart?.item_count || 0;
        if (count > 0) {
          headerCount.textContent = count;
          headerCount.style.display = 'flex';
        } else {
          headerCount.style.display = 'none';
        }
      }
    }

    formatMoney(cents) {
      const currency = this.cart?.currency || this.cartDrawer?.dataset.currency || 'USD';
      const locale = this.cartDrawer?.dataset.locale || 'en';
      
      try {
        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        });
        return formatter.format(cents / 100);
      } catch (e) {
        // Fallback if currency formatting fails
        return `${(cents / 100).toFixed(2)} ${currency}`;
      }
    }

    open() {
      if (!this.cartDrawer) return;
      
      this.cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer--active');
      
      // Refresh cart when opening
      this.refreshCart();
    }

    close() {
      if (!this.cartDrawer) return;
      
      this.cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer--active');
    }

    isOpen() {
      return this.cartDrawer?.getAttribute('aria-hidden') === 'false';
    }

    toggle() {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  // Initialize cart drawer
  document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawer = new CartDrawer();
  });

  // Listen for add to cart events
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      // Wait a bit for the cart to update
      setTimeout(() => {
        if (window.cartDrawer) {
          window.cartDrawer.refreshCart();
          // Open cart drawer after adding item (if using drawer)
          if (window.cartDrawer.isOpen() === false) {
            window.cartDrawer.open();
          }
        }
      }, 500);
    }
  });

  // Listen for cart updates from other sources
  document.addEventListener('cart:add', () => {
    if (window.cartDrawer) {
      setTimeout(() => {
        window.cartDrawer.refreshCart();
      }, 500);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bought-together"] && !Shopify.designMode) return;
  try {
    (function() {
    function initBoughtTogether() {
      document.querySelectorAll('[data-bought-together]').forEach(function(wrapper) {
        if (wrapper.dataset.initialized) return;
        wrapper.dataset.initialized = 'true';

        const cartType = wrapper.dataset.cartType || 'page';
        const addingText = wrapper.dataset.addingText || 'Adding...';
        const addErrorText = wrapper.dataset.addErrorText || 'Failed to add item to cart. Please try again.';

        wrapper.querySelectorAll('[data-bought-together-add]').forEach(function(button) {
          if (!button.dataset.variantId) return;

          button.addEventListener('click', async function() {
            const variantId = button.dataset.variantId;
            if (!variantId) return;

            button.disabled = true;
            button.classList.add('is-loading');
            button.setAttribute('aria-busy', 'true');

            try {
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1
                })
              });

              if (!response.ok) {
                const error = await response.json();
                throw new Error(error.description || addErrorText);
              }

              if (cartType === 'drawer') {
                await new Promise(function(resolve) {
                  setTimeout(resolve, 100);
                });

                if (window.cartDrawer) {
                  await window.cartDrawer.refreshCart();
                  window.cartDrawer.open();
                }
              }

              document.dispatchEvent(new CustomEvent('cart:add'));
            } catch (error) {
              console.error('Error adding bought-together item to cart:', error);
              alert(error.message || addErrorText);
            } finally {
              button.disabled = false;
              button.classList.remove('is-loading');
              button.removeAttribute('aria-busy');
            }
          });
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBoughtTogether);
    } else {
      initBoughtTogether();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() { 
    
    const productForm = document.querySelector('.product__form');
    if (!productForm) return;

    const isUpcoming = productForm.dataset.productUpcoming === 'true';
    const upcomingLabel = productForm.dataset.upcomingLabel || '';
    const inStockText = productForm.dataset.inStockText || 'In stock';
    const lowStockTextStart = productForm.dataset.lowStockTextStart || 'Only';
    const lowStockTextEnd = productForm.dataset.lowStockTextEnd || 'left in stock';
    const outOfStockText = productForm.dataset.outOfStockText || 'Out of stock';
    const addToCartLabel = productForm.dataset.addToCartText || 'Add to basket';
    const soldOutText = productForm.dataset.soldOutText || 'Sold out';
    const selectOptionsText = productForm.dataset.selectOptionsText || 'Select options';
    const addingText = productForm.dataset.addingText || 'Adding...';
    const selectAllOptionsAlert = productForm.dataset.selectAllOptionsAlert || 'Please select all options';
    const addToCartError = productForm.dataset.addToCartError || 'Failed to add item to cart. Please try again.';

    const productFormElement = productForm.querySelector('form');
    const cartType = productForm.dataset.cartType || 'page';
    const variantIdInput = document.getElementById('product-variant-id');
    const optionSelects = productForm.querySelectorAll('.product-option-select');
    const optionPickers = productForm.querySelectorAll('[data-option-picker]');
    const stockElement = document.querySelector('.product__stock');
    const addToCartButton = document.querySelector('.product__form button[data-add-to-cart-button]');
    const addToCartText = addToCartButton?.querySelector('[data-add-to-cart-text]');
    const addToCartPrice = addToCartButton?.querySelector('[data-add-to-cart-price]');
    const addToCartCompareAt = addToCartButton?.querySelector('[data-add-to-cart-compare-at]');
    const mainSwiper = document.querySelector('.product__images-main');
    
    // Load variant data
    const variantsDataElement = document.getElementById('product-variants-data');
    const variants = variantsDataElement ? JSON.parse(variantsDataElement.textContent) : [];
    
    const originalButtonText = addToCartLabel;

    function formatLowStockMessage(quantity) {
      const count = String(quantity);
      return [lowStockTextStart, count, lowStockTextEnd].filter(part => part !== '').join(' ');
    }

    // Function to find variant based on selected options
    function findVariant() {
      // If no option selects exist (single variant product), return the first variant
      if (optionSelects.length === 0) {
        return variants.length > 0 ? variants[0] : null;
      }
      
      const selectedOptions = {};
      
      optionSelects.forEach(select => {
        const position = parseInt(select.dataset.optionPosition);
        const value = select.value;
        if (value) {
          selectedOptions[position] = value;
        }
      });
      
      // Find matching variant
      const matchingVariant = variants.find(variant => {
        const option1Match = !selectedOptions[1] || variant.option1 === selectedOptions[1];
        const option2Match = !selectedOptions[2] || variant.option2 === selectedOptions[2];
        const option3Match = !selectedOptions[3] || variant.option3 === selectedOptions[3];
        return option1Match && option2Match && option3Match;
      });
      
      return matchingVariant || null;
    }

    optionPickers.forEach((picker, pickerIndex) => {
      const trigger = picker.querySelector('[data-option-trigger]');
      const triggerLabel = picker.querySelector('[data-option-trigger-label]');
      const list = picker.querySelector('[data-option-list]');
      const items = picker.querySelectorAll('[data-option-item]');
      const nativeSelect = optionSelects[pickerIndex];

      if (!trigger || !list || !nativeSelect) return;

      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          list.setAttribute('hidden', '');
        } else {
          list.removeAttribute('hidden');
        }
      });

      items.forEach(item => {
        item.addEventListener('click', () => {
          const value = item.getAttribute('data-option-value') || '';
          nativeSelect.value = value;
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

          if (triggerLabel) triggerLabel.textContent = value;
          items.forEach(node => node.classList.remove('is-selected'));
          item.classList.add('is-selected');

          trigger.setAttribute('aria-expanded', 'false');
          list.setAttribute('hidden', '');
        });
      });
    });
    
    // Function to update form based on selected variant
    function updateVariant(variant) {
      if (!variant) {
        // No variant selected or invalid combination
        if (variantIdInput) {
          variantIdInput.value = '';
        }
        if (addToCartButton) {
          addToCartButton.disabled = true;
          if (addToCartText) addToCartText.textContent = selectOptionsText;
        }
        if (stockElement) {
          stockElement.innerHTML = '';
        }
        return;
      }
      
      // Update hidden variant ID input
      if (variantIdInput) {
        variantIdInput.value = variant.id;
        if (variant.featured_image) {
          variantIdInput.setAttribute('data-variant-image', variant.featured_image);
        } else {
          variantIdInput.removeAttribute('data-variant-image');
        }
      }
      
      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.pushState({}, '', url);
      
      // Update stock availability
      if (stockElement) {
        stockElement.setAttribute('data-variant-id', variant.id);
        let stockHtml = '';

        if (isUpcoming) {
          stockHtml = `<span class="product__stock--upcoming">${upcomingLabel}</span>`;
        } else if (variant.available) {
          const inventoryTracked = variant.inventory_management != null;
          const inventoryQuantity = variant.inventory_quantity || 0;
          if (inventoryTracked && inventoryQuantity > 0 && inventoryQuantity <= 10) {
            stockHtml = `<span class="product__stock--low">${formatLowStockMessage(inventoryQuantity)}</span>`;
          } else {
            stockHtml = `<span class="product__stock--available">${inStockText}</span>`;
          }
        } else {
          stockHtml = `<span class="product__stock--unavailable">${outOfStockText}</span>`;
        }

        stockElement.innerHTML = stockHtml;
      }

      if (addToCartPrice) {
        addToCartPrice.textContent = variant.price_formatted || '';
      }

      if (addToCartCompareAt) {
        const showCompareAt = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (showCompareAt) {
          addToCartCompareAt.textContent = variant.compare_at_price_formatted || '';
          addToCartCompareAt.hidden = false;
        } else {
          addToCartCompareAt.hidden = true;
        }
      }
      
      // Update add to cart button
      if (addToCartButton) {
        if (isUpcoming) {
          addToCartButton.disabled = true;
          if (addToCartText) addToCartText.textContent = upcomingLabel;
        } else if (variant.available) {
          addToCartButton.disabled = false;
          if (addToCartText) addToCartText.textContent = originalButtonText;
        } else {
          addToCartButton.disabled = true;
          if (addToCartText) addToCartText.textContent = soldOutText;
        }
      }
      
      // Update images if variant has a specific image
      if (variant.featured_image && mainSwiper) {
        const slides = mainSwiper.slides;
        const imageIndex = Array.from(slides).findIndex(slide => {
          const img = slide.querySelector('img');
          return img && img.src === variant.featured_image;
        });
        
        if (imageIndex !== -1) {
          mainSwiper.slideTo(imageIndex);
        }
      }
    }
    
    // Handle form submission for cart drawer
    if (productFormElement && cartType === 'drawer') {
      productFormElement.addEventListener('submit', async function(e) {
        e.preventDefault();
        
        const formData = new FormData(productFormElement);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || '1', 10);
        
        if (!variantId) {
          alert(selectAllOptionsAlert);
          return;
        }
        
        // Disable button during submission
        if (addToCartButton) {
          addToCartButton.disabled = true;
          if (addToCartText) addToCartText.textContent = addingText;
        }
        
        try {
          // Add item to cart via AJAX
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });
          
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Failed to add item to cart');
          }
          
          // Refresh cart drawer and open it
          if (window.cartDrawer) {
            await window.cartDrawer.refreshCart();
            window.cartDrawer.open();
          }
          
          // Dispatch cart add event
          document.dispatchEvent(new CustomEvent('cart:add'));
          
          // Re-enable button
          if (addToCartButton) {
            addToCartButton.disabled = false;
            if (addToCartText) addToCartText.textContent = originalButtonText;
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert(error.message || addToCartError);
          
          // Re-enable button
          if (addToCartButton) {
            addToCartButton.disabled = false;
            if (addToCartText) addToCartText.textContent = originalButtonText;
          }
        }
      });
    }
    
    // Only set up option select listeners if option selects exist
    if (optionSelects.length > 0) {
      // Listen to changes on all option selects
      optionSelects.forEach(select => {
        select.addEventListener('change', function() {
          const optionField = this.closest('.form__field');
          const picker = optionField ? optionField.querySelector('[data-option-picker]') : null;
          if (picker) {
            const triggerLabel = picker.querySelector('[data-option-trigger-label]');
            const items = picker.querySelectorAll('[data-option-item]');
            if (triggerLabel) triggerLabel.textContent = this.value;
            items.forEach(item => {
              const isSelected = item.getAttribute('data-option-value') === this.value;
              item.classList.toggle('is-selected', isSelected);
            });
          }
          const variant = findVariant();
          updateVariant(variant);
        });
      });
      
      // Initialize with current variant
      const currentVariant = findVariant();
      if (currentVariant) {
        updateVariant(currentVariant);
      }
    }

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() { 

    // Move zoom modal to body level to ensure proper positioning
    const zoomModal = document.getElementById('productZoomModal');
    if (zoomModal && zoomModal.parentElement !== document.body) {
      document.body.appendChild(zoomModal);
    }

    const thumbs = new Swiper('.product__images-thumbs', {
      direction: 'horizontal',
      spaceBetween: 8,
      slidesPerView: 6,
      speed: 0,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      mousewheel: false,
      breakpoints: {
        768: {
          direction: 'vertical',
          slidesPerView: 6,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            eventsTarget: 'container',
          },
        },
      },
    });

    const main = new Swiper('.product__images-main', {
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',
      speed: 0,
      autoHeight: true,
      observer: true,
      observeParents: true,
      loop: false,
      thumbs: { 
        swiper: thumbs 
      },
      mousewheel: false,
      breakpoints: {
        768: {
          direction: 'vertical',
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
            eventsTarget: 'container',
          },
        },
      },
    });

    // Zoom functionality
    if (!zoomModal) return; // Safety check
    
    const zoomClose = zoomModal.querySelector('.product__zoom-close');
    const zoomImage = zoomModal.querySelector('.product__zoom-image');
    const zoomImageWrapper = zoomModal.querySelector('.product__zoom-image-wrapper');
    const zoomVideoWrapper = zoomModal.querySelector('.product__zoom-video-wrapper');
    const zoomVideo = zoomModal.querySelector('.product__zoom-video');
    const zoomButtons = document.querySelectorAll('.product__image-zoom-btn');
    const mainSlides = document.querySelectorAll('.product__media-slide');

    let currentScale = 1;
    let currentX = 0;
    let currentY = 0;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let initialDistance = 0;
    let initialScale = 1;

    function openZoom(imageSrc, imageAlt, isVideo, videoElement) {
      // Hide video wrapper, show image wrapper
      zoomVideoWrapper.style.display = 'none';
      zoomImageWrapper.style.display = 'flex';
      
      if (isVideo && videoElement) {
        // Handle video zoom
        zoomVideoWrapper.style.display = 'flex';
        zoomImageWrapper.style.display = 'none';
        
        // Clone video element or use sources
        const videoSources = videoElement.querySelectorAll('source');
        zoomVideo.innerHTML = '';
        videoSources.forEach(source => {
          const newSource = source.cloneNode(true);
          zoomVideo.appendChild(newSource);
        });
        
        // Copy video attributes
        if (videoElement.hasAttribute('poster')) {
          zoomVideo.poster = videoElement.getAttribute('poster');
        }
        zoomVideo.load();
      } else {
        // Handle image zoom
        zoomImage.src = imageSrc;
        zoomImage.alt = imageAlt || 'Product image';
        // Remove width/height constraints when zooming - let image scale naturally
        zoomImage.removeAttribute('width');
        zoomImage.removeAttribute('height');
      }
      
      zoomModal.setAttribute('aria-hidden', 'false');
      
      // Prevent background scrolling while zoom is open.
      document.body.classList.add('product__zoom-open');
      document.documentElement.classList.add('product__zoom-open');
      
      // Reset zoom and position (only for images)
      if (!isVideo) {
        currentScale = 1;
        currentX = 0;
        currentY = 0;
        updateTransform();
        updateCursor();
      }
    }

    function closeZoom() {
      zoomModal.setAttribute('aria-hidden', 'true');
      
      // Pause video if playing
      if (zoomVideo) {
        zoomVideo.pause();
        zoomVideo.currentTime = 0;
      }
      
      // Re-enable scrolling
      document.body.classList.remove('product__zoom-open');
      document.documentElement.classList.remove('product__zoom-open');
      
      currentScale = 1;
      currentX = 0;
      currentY = 0;
    }

    function updateTransform() {
      zoomImage.style.transform = `translate(${currentX}px, ${currentY}px) scale(${currentScale})`;
      updateCursor();
    }

    function updateCursor() {
      if (!isDragging) {
        if (currentScale > 1) {
          zoomImageWrapper.style.cursor = 'grab';
          zoomImageWrapper.classList.add('zoomable');
        } else {
          zoomImageWrapper.style.cursor = 'grabbing';
          zoomImageWrapper.classList.remove('zoomable');
        }
      }
    }

    function constrainPosition() {
      const rect = zoomImage.getBoundingClientRect();
      const containerRect = zoomImageWrapper.getBoundingClientRect();
      
      const maxX = (rect.width * currentScale - containerRect.width) / 2;
      const maxY = (rect.height * currentScale - containerRect.height) / 2;
      
      currentX = Math.max(-maxX, Math.min(maxX, currentX));
      currentY = Math.max(-maxY, Math.min(maxY, currentY));
      
      updateTransform();
    }

    // Open zoom on button click
    zoomButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        const imageSrc = this.getAttribute('data-image-src');
        const imageIndex = parseInt(this.getAttribute('data-image-index'));
        const slideElement = this.closest('.product__media-slide');
        const imageElement = slideElement.querySelector('img');
        const imageAlt = imageElement ? imageElement.alt : '';
        openZoom(imageSrc, imageAlt, false, null);
      });
    });

    // Close zoom
    zoomClose.addEventListener('click', closeZoom);
    
    zoomModal.addEventListener('click', function(e) {
      if (e.target === zoomModal || e.target === zoomImageWrapper) {
        closeZoom();
      }
    });
    
    // Pause videos when slide changes
    main.on('slideChange', function() {
      mainSlides.forEach((slide, index) => {
        if (index !== main.activeIndex) {
          const video = slide.querySelector('video');
          if (video) {
            video.pause();
          }
        }
      });
    });

    // Keyboard support
    document.addEventListener('keydown', function(e) {
      if (zoomModal.getAttribute('aria-hidden') === 'false') {
        if (e.key === 'Escape') {
          closeZoom();
        }
      }
    });

    // Mouse wheel zoom
    zoomImageWrapper.addEventListener('wheel', function(e) {
      e.preventDefault();
      
      const delta = e.deltaY > 0 ? 0.9 : 1.1;
      const newScale = Math.max(1, Math.min(5, currentScale * delta));
      
      if (newScale !== currentScale) {
        const rect = zoomImageWrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const scaleChange = newScale / currentScale;
        currentX = x - (x - currentX) * scaleChange;
        currentY = y - (y - currentY) * scaleChange;
        
        currentScale = newScale;
        updateTransform();
        constrainPosition();
      }
    }, { passive: false });

    // Touch pinch zoom
    let touches = [];
    
    zoomImageWrapper.addEventListener('touchstart', function(e) {
      e.preventDefault();
      touches = Array.from(e.touches);
      
      if (touches.length === 1) {
        isDragging = true;
        startX = touches[0].clientX - currentX;
        startY = touches[0].clientY - currentY;
      } else if (touches.length === 2) {
        isDragging = false;
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        initialDistance = Math.sqrt(dx * dx + dy * dy);
        initialScale = currentScale;
      }
    }, { passive: false });

    zoomImageWrapper.addEventListener('touchmove', function(e) {
      e.preventDefault();
      touches = Array.from(e.touches);
      
      if (touches.length === 1 && isDragging) {
        currentX = touches[0].clientX - startX;
        currentY = touches[0].clientY - startY;
        constrainPosition();
      } else if (touches.length === 2) {
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (initialDistance > 0) {
          const scale = distance / initialDistance;
          currentScale = Math.max(1, Math.min(5, initialScale * scale));
          updateTransform();
          constrainPosition();
        }
      }
    }, { passive: false });

    zoomImageWrapper.addEventListener('touchend', function(e) {
      e.preventDefault();
      touches = Array.from(e.touches);
      isDragging = false;
      
      if (touches.length < 2) {
        initialDistance = 0;
      }
    }, { passive: false });

    // Mouse drag
    zoomImageWrapper.addEventListener('mousedown', function(e) {
      // Only start dragging if clicking on the image or wrapper, not buttons
      if (e.target.closest('.product__zoom-close')) return;
      
      e.preventDefault();
      isDragging = true;
      startX = e.clientX - currentX;
      startY = e.clientY - currentY;
      zoomImageWrapper.classList.add('dragging');
      
      // Update cursor based on zoom level
      if (currentScale > 1) {
        zoomImageWrapper.style.cursor = 'grabbing';
      }
    });

    document.addEventListener('mousemove', function(e) {
      if (isDragging) {
        e.preventDefault();
        currentX = e.clientX - startX;
        currentY = e.clientY - startY;
        
        // Only constrain if zoomed in
        if (currentScale > 1) {
          constrainPosition();
        } else {
          // Reset position if not zoomed
          currentX = 0;
          currentY = 0;
          updateTransform();
        }
      }
    });

    document.addEventListener('mouseup', function(e) {
      if (isDragging) {
        isDragging = false;
        zoomImageWrapper.classList.remove('dragging');
        
        // Update cursor based on zoom level
        if (currentScale > 1) {
          zoomImageWrapper.style.cursor = 'grab';
          zoomImageWrapper.classList.add('zoomable');
        } else {
          zoomImageWrapper.style.cursor = 'grabbing';
          zoomImageWrapper.classList.remove('zoomable');
        }
      }
    });

    // Initialize cursor
    updateCursor();

    // Handle video clicks to open in zoom modal
    const videoWrappers = document.querySelectorAll('.product__media-video-wrapper');
    videoWrappers.forEach(wrapper => {
      const video = wrapper.querySelector('video');
      if (video) {
        wrapper.addEventListener('click', function(e) {
          // Don't open modal if clicking on video controls
          if (e.target.tagName === 'VIDEO' || e.target.closest('video')) {
            return;
          }
          
          const mediaIndex = parseInt(this.getAttribute('data-media-index'));
          const videoSources = video.querySelectorAll('source');
          
          // Open video in zoom modal
          openZoom('', '', true, video);
        });
      }
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const videoBlocks = document.querySelectorAll('.product__grid-video[data-custom-video-controls]');

    videoBlocks.forEach((videoBlock) => {
      const video = videoBlock.querySelector('.product__grid-video-el');
      const playButton = videoBlock.querySelector('[data-video-toggle-play]');
      const muteButton = videoBlock.querySelector('[data-video-toggle-mute]');
      const overlayPlayButton = videoBlock.querySelector('[data-video-overlay-play]');
      const shouldAutoplay = videoBlock.dataset.videoAutoplay === 'true';
      let hasStarted = shouldAutoplay;

      if (!video || !playButton || !muteButton || !overlayPlayButton) return;

      const syncState = () => {
        videoBlock.classList.toggle('is-paused', video.paused);
        videoBlock.classList.toggle('is-unmuted', !video.muted);
        videoBlock.classList.toggle('is-not-started', !hasStarted);

        playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      };

      overlayPlayButton.addEventListener('click', () => {
        hasStarted = true;
        video.play();
        syncState();
      });

      playButton.addEventListener('click', () => {
        if (video.paused) {
          hasStarted = true;
          video.play();
        } else {
          video.pause();
        }
        syncState();
      });

      muteButton.addEventListener('click', () => {
        video.muted = !video.muted;
        syncState();
      });

      video.addEventListener('play', syncState);
      video.addEventListener('pause', syncState);
      video.addEventListener('volumechange', syncState);

      syncState();
    });

    const lightboxGrids = document.querySelectorAll('[data-product-media-lightbox]');

    lightboxGrids.forEach((grid) => {
      const productId = grid.getAttribute('data-product-media-lightbox');
      const modal = document.getElementById(`product-media-lightbox-${productId}`);
      if (!modal) return;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      const triggers = grid.querySelectorAll('[data-media-lightbox-index]');
      const slides = modal.querySelectorAll('[data-lightbox-slide]');
      const closeButton = modal.querySelector('[data-media-lightbox-close]');
      const prevButton = modal.querySelector('[data-media-lightbox-prev]');
      const nextButton = modal.querySelector('[data-media-lightbox-next]');
      let activeIndex = 0;

      const pauseSlideVideos = (slide) => {
        if (!slide) return;
        slide.querySelectorAll('video').forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });
      };

      const updateNavButtons = () => {
        if (!prevButton || !nextButton) return;
        prevButton.disabled = activeIndex <= 0;
        nextButton.disabled = activeIndex >= slides.length - 1;
      };

      const showSlide = (index) => {
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        slides.forEach((slide, slideIndex) => {
          if (slideIndex === nextIndex) {
            slide.hidden = false;
          } else {
            pauseSlideVideos(slide);
            slide.hidden = true;
          }
        });
        activeIndex = nextIndex;
        updateNavButtons();
      };

      const openLightbox = (index) => {
        showSlide(index);
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('product__media-lightbox-open');
        document.documentElement.classList.add('product__media-lightbox-open');
        closeButton?.focus();
      };

      const closeLightbox = () => {
        slides.forEach((slide) => pauseSlideVideos(slide));
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('product__media-lightbox-open');
        document.documentElement.classList.remove('product__media-lightbox-open');
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = parseInt(trigger.getAttribute('data-media-lightbox-index'), 10);
          if (Number.isNaN(index)) return;
          openLightbox(index);
        });
      });

      closeButton?.addEventListener('click', closeLightbox);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeLightbox();
        }
      });

      prevButton?.addEventListener('click', () => {
        if (activeIndex > 0) showSlide(activeIndex - 1);
      });

      nextButton?.addEventListener('click', () => {
        if (activeIndex < slides.length - 1) showSlide(activeIndex + 1);
      });

      document.addEventListener('keydown', (event) => {
        if (modal.getAttribute('aria-hidden') !== 'false') return;

        if (event.key === 'Escape') {
          closeLightbox();
        } else if (event.key === 'ArrowLeft' && activeIndex > 0) {
          showSlide(activeIndex - 1);
        } else if (event.key === 'ArrowRight' && activeIndex < slides.length - 1) {
          showSlide(activeIndex + 1);
        }
      });

      updateNavButtons();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() { 

    const tabButtons = document.querySelectorAll('.product__tab-button');
    const tabPanels = document.querySelectorAll('.product__tab-panel');

    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');
        const targetPanel = document.getElementById(`tab-${targetTab}`);

        tabButtons.forEach(btn => {
          btn.setAttribute('aria-selected', 'false');
          btn.classList.remove('active');
        });
        tabPanels.forEach(panel => {
          panel.setAttribute('data-active', 'false');
        });

        this.setAttribute('aria-selected', 'true');
        this.classList.add('active');
        if (targetPanel) {
          targetPanel.setAttribute('data-active', 'true');
        }
      });
    });

  });
  } catch(e) { console.error(e); }
})();

})();
